export default "__VITE_ASSET__lp78TUpr__"